export default __webpack_public_path__ + "static/media/enamarainterview.80e93e2d.png";